module.exports = __webpack_public_path__ + "img/empty-preview.981836b0.svg";